import { isPlatformServer } from '@angular/common';
import { Inject, Optional, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { RESPONSE } from '@nguniversal/express-engine/tokens';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonChip,
  IonIcon,
  IonLabel,
  IonButton,
} from '@ionic/angular/standalone';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.page.html',
  styleUrls: ['./not-found.page.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    CommonModule,
    FormsModule,
    IonChip,
    IonIcon,
    IonLabel,
    IonButton,
    RouterLink,
  ],
})
export class NotFoundPage implements OnInit {
  unknownPath = '';
  // not-found.page.ts (add this line)
  homeRoute = ['/folder', 'inbox']; // or const if you prefer

  constructor(
    private route: ActivatedRoute,
    private title: Title,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    // 1. Show the wrong path that user/bot tried to visit
    // route.snapshot.url is an array of UrlSegment → join them
    this.unknownPath =
      this.route.snapshot.url.map((segment) => segment.path).join('/') ||
      '(root)';

    // 2. SEO basics
    this.title.setTitle('Page not found – Your Site Name');
    // the default is already index,follow. You never have to write content: 'index' anywhere.
    this.meta.updateTag({ name: 'robots', content: 'noindex' });

    // 3. Return real 404 status code for crawlers (SSR only)
    // This works in Ionic + Capacitor when you use @angular/ssr (Angular 17+)
    // No extra dependency needed – @angular/ssr already provides RESPONSE token
    if (isPlatformServer(this.platformId)) {
      // This line is safe even if RESPONSE is not provided (Capacitor/browser)
      // It only does something when running on the server
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // win is a reference to the global object of the current execution environment
      const win = globalThis as any;
      if (win?.response) {
        win.response.statusCode = 404;
      }
    }
  }
}
